import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  EDITOR_LOAD_SNIPPETS_BEGIN,
  EDITOR_LOAD_SNIPPETS_SUCCESS,
  EDITOR_LOAD_SNIPPETS_FAILURE,
  EDITOR_LOAD_SNIPPETS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
export function loadSnippets(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_LOAD_SNIPPETS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/min/snippet-templates`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EDITOR_LOAD_SNIPPETS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EDITOR_LOAD_SNIPPETS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}
export function dismissLoadSnippetsError() {
  return {
    type: EDITOR_LOAD_SNIPPETS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_LOAD_SNIPPETS_BEGIN:
      return {
        ...state,
        loadSnippetsPending: true,
        loadSnippetsError: null,
      };

    case EDITOR_LOAD_SNIPPETS_SUCCESS:
      return {
        ...state,
        loadSnippetsPending: false,
        loadSnippetsError: null,
        snippets: action.data,
      };

    case EDITOR_LOAD_SNIPPETS_FAILURE:
      return {
        ...state,
        loadSnippetsPending: false,
        loadSnippetsError: action.data.error,
      };

    case EDITOR_LOAD_SNIPPETS_DISMISS_ERROR:
      return {
        ...state,
        loadSnippetsError: null,
      };

    default:
      return state;
  }
}
